import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'

import Linkedin from 'assets/svg/footer/linkedin.svg'
import Instagram from 'assets/svg/footer/instagram.svg'
import InstagramRetail from 'assets/svg/footer/instagram-retail.svg'
import Facebook from 'assets/svg/footer/facebook.svg'
import FacebokRetail from 'assets/svg/footer/facebook-retail.svg'
import Youtube from 'assets/svg/footer/youtube.svg'

import LinkedinWhite from 'assets/svg/footer/linkedin-white.svg'
import InstagramWhite from 'assets/svg/footer/instagram-white.svg'
import FacebookWhite from 'assets/svg/footer/facebook-white.svg'
import YoutubeWhite from 'assets/svg/footer/youtube-white.svg'

const Footer = () => {
  const location = useLocation()
  const isOrangeTheme = location.pathname === '/retail'
  return (
    <footer className={isOrangeTheme ? 'bg-[#F4633A]' : 'bg-[#071126]'}>
      <div className="py-10 px-6 lg:px-14 xl:px-[120px] lg:pt-[56px] lg:pb-[32px] max-w-[1440px] m-auto left-0 right-0">
        <div className="flex flex-col sm:flex-row justify-between mb-8 lg:mb-10 gap-y-10">
          <div className="lg:w-[290px]">
            <ManuvaLogo />
            <div className="mt-4 lg:mt-8">
              <p className="text-s-reguler lg:text-m-reguler text-white">
                CoHive - Sahid Sudirman Residence
              </p>
              <p className="text-s-reguler lg:text-m-reguler text-white">
                Jl. Jend. Sudirman No.86, Tanah Abang, Kota Jakarta Pusat,
                Daerah Khusus Ibukota Jakarta 10250.
              </p>
            </div>
          </div>

          <div
            className={`grid grid-cols-[150px_150px] gap-x-6 gap-y-10
          lg:gap-x-8 lg:gap-y-16 lg:grid-cols-[204px_204px] 
          xl:gap-x-0 xl:gap-y-0 xl:grid-cols-[205px_205px_205px_173px]`}
          >
            <div className="w-[74px]">
              <h1 className="text-white text-m-bold">Company</h1>
              <ul className="mt-4 flex flex-col gap-y-3">
                <li
                  className={`${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  About Us
                </li>
                <li
                  className={`${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  Contact
                </li>
                <li
                  className={`${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  Career
                </li>
              </ul>
            </div>

            <div className="w-[117px]">
              <h1 className="text-white text-m-bold">Solutions</h1>
              <ul className="mt-4 flex flex-col gap-y-3">
                <li
                  className={`${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  Manuva Retail
                </li>
                <li
                  className={`${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  Manuva Procure
                </li>
                <li
                  className={`${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  Manuva Supply
                </li>
              </ul>
            </div>

            <div className="w-[156px] order-4 xl:order-3">
              <h1 className="text-white text-m-bold">Policies</h1>
              <ul className="mt-4 flex flex-col gap-y-3">
                <li
                  className={`w-[125px] sm:w-auto ${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  Terms and Conditions
                </li>
              </ul>
            </div>

            <div className="w-[127px] order-3 xl:order-4">
              <h1 className="text-white text-m-bold">Keep Connected</h1>
              <ul className="mt-4 flex flex-col gap-y-2">
                <li
                  className={`flex items-center gap-x-2 ${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  <img src={isOrangeTheme ? LinkedinWhite : Linkedin} alt="" />
                  Manuva
                </li>
                <li
                  className={`flex items-center gap-x-2 ${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  <img
                    src={isOrangeTheme ? InstagramWhite : Instagram}
                    alt=""
                  />
                  Manuva
                </li>
                <li
                  className={`flex items-center gap-x-2 ${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  <img
                    src={isOrangeTheme ? InstagramWhite : InstagramRetail}
                    alt=""
                  />
                  ManuvaRetail
                </li>
                <li
                  className={`flex items-center gap-x-2 ${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  <img src={isOrangeTheme ? FacebookWhite : Facebook} alt="" />
                  Manuva
                </li>
                <li
                  className={`flex items-center gap-x-2 ${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  <img
                    src={isOrangeTheme ? FacebookWhite : FacebokRetail}
                    alt=""
                  />
                  ManuvaRetail
                </li>
                <li
                  className={`flex items-center gap-x-2 ${
                    isOrangeTheme ? 'text-white' : 'text-neutral-50'
                  } text-m-reguler`}
                >
                  <img src={isOrangeTheme ? YoutubeWhite : Youtube} alt="" />
                  Manuva
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="pt-6 lg:pt-8 flex justify-between items-center border-t border-t-white">
          <p className="text-white text-sm leading-[150%]">
            © 2022. Manuva. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

const ManuvaLogo = ({ className }) => {
  return (
    <svg
      className={className}
      width="175"
      height="38"
      viewBox="0 0 175 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.088 30.4513C13.3936 29.1261 16.6112 15.2798 27.1019 12.9143V7.47559C22.5464 8.17859 16.5788 11.0286 13.3056 16.0493L13.0603 16.4293L13.088 10.9241H7.40747V30.4323L13.088 30.4513Z"
        fill="white"
      />
      <path
        d="M41.1668 7.47559V12.9143C30.6761 15.2893 27.4539 29.1261 27.1529 30.4513H21.4492V17.8733C23.8566 15.4461 26.2733 14.6861 27.1251 14.6671V16.4246L27.3705 16.0493C30.639 11.0286 36.6298 8.17859 41.1668 7.47559Z"
        fill="white"
      />
      <path
        d="M41.1668 14.667V30.4512H35.4908V17.8732C37.8936 15.446 40.3149 14.686 41.1668 14.667Z"
        fill="white"
      />
      <path
        d="M51.3428 27.8915V9.65625H58.7502L61.528 22.0063H61.5742L64.2456 9.65625H71.5326V27.8915H67.4307V12.6392L67.3845 12.587L63.4261 27.8915H59.2039L55.5002 12.4588L55.4539 12.511V27.8915H51.3428Z"
        fill="white"
      />
      <path
        d="M73.514 27.8915L80.2177 9.65625H85.9122L92.5927 27.8915H87.2964L86.1714 24.329H79.2918L78.19 27.8915H73.514ZM85.0233 20.795L82.8659 13.2188H82.7964L80.4816 20.795H85.0233Z"
        fill="white"
      />
      <path
        d="M94.3287 9.65625H100.889L106.56 23.246L106.607 23.1938V9.65625H110.829V27.8915H104.347L98.6065 13.9265H98.5602V27.8915H94.3426L94.3287 9.65625Z"
        fill="white"
      />
      <path
        d="M130.185 9.65625V21.1988C130.139 26.2765 126.366 28.2715 122.102 28.2715C117.838 28.2715 114.06 26.2765 114.014 21.1988V9.65625H118.704V20.947C118.773 23.2698 119.898 24.747 122.102 24.747C124.305 24.747 125.43 23.284 125.5 20.947V9.65625H130.185Z"
        fill="white"
      />
      <path
        d="M145.185 9.65625H149.852L143.685 27.8915H138.088L132.111 9.65625H137.292L141.111 22.866H141.157L145.185 9.65625Z"
        fill="white"
      />
      <path
        d="M148.583 27.8915L155.264 9.65625H160.982L167.662 27.8915H162.366L161.241 24.329H154.375L153.273 27.8915H148.583ZM160.093 20.795L157.935 13.2188H157.866L155.551 20.795H160.093Z"
        fill="white"
      />
    </svg>
  )
}

ManuvaLogo.propTypes = {
  className: PropTypes.string
}

export default Footer
